// extracted by mini-css-extract-plugin
module.exports = {"head":"ArticleDetailHeadItemDay_head__JGfnu","date":"ArticleDetailHeadItemDay_date__cENma","headline":"ArticleDetailHeadItemDay_headline__JwoVn"};